import React from "react";
import Logo from "assets/blue-logo.png";

const CorticaLogo = () => (
  <img
    id="cortica-logo"
    src={Logo}
    alt="cortica-logo"
    style={{ display: "block", width: "100%", height: "auto" }}
  />
);

export default CorticaLogo;
